import React from 'react';
import Form from "../../common/Form";
import JoiBase from "joi";
import {FormattedMessage, injectIntl} from "react-intl";
import JoiDate from "@hapi/joi-date";
import {UpdateWorldRegion, CreateNewWorldRegion} from "../../../../services/worldregionsService";
import DisplayFormErrors from "../../common/formElements/DisplayFormErrors";
import {withRouter} from "react-router-dom";

const Joi = JoiBase.extend(JoiDate); // extend Joi with Joi Date

class WorldRegionForm extends Form {

    state = {
        locale : this.props.locale,
        worldRegion : this.props.worldRegion,

        errors:{}
    }

    constructor(props) {
        super(props);
        const currentWorldRegion = this.props.worldRegion;
        this.state.sendButtonDisabled = false;

        this.state.data = {
            id : currentWorldRegion.id,
            active : (currentWorldRegion.active === 1)?true:false,
            fr : currentWorldRegion.fr,
            en : currentWorldRegion.en,

            errors:[]
        };

    }

    schemaDefinition = {
        id: Joi.number(),
        active : Joi.boolean(),
        fr: Joi.string().required(),
        en : Joi.string().required()
    };

    doSubmit = async e => {
        this.setState({sendButtonDisabled:true})
        let worldRegionObject = {...this.state.data};

        delete worldRegionObject.errors;
        if(worldRegionObject.id){
            try{
                await UpdateWorldRegion(worldRegionObject);
                this.props.history.goBack();
            }catch(err){
                console.error(err.message);
            }
        }
        else{
            try{
                await CreateNewWorldRegion(worldRegionObject);
                this.props.history.goBack();
            }catch(err){
                console.error(err.message);
            }
        }

    };


    render() {
        //console.log(JSON.stringify(this.state.data));
        return (
            <>
                <div className="container">
                    <h1><FormattedMessage id="worldregion.form.h1" /> {this.props.worldRegion.id}</h1>
                    <DisplayFormErrors
                        errors = {this.state.data.errors}
                    />

                    <form onSubmit={this.handleSubmit}>
                        <h2><FormattedMessage id="worldregion.form.h2" /></h2>
                            {this.renderInput("fr", "worldregion.form.fr")}
                            {this.renderInput("en", "worldregion.form.en")}
                            {this.renderCheckBox("active", "worldregion.form.active")}
                        <button disabled={this.state.sendButtonDisabled} className="btn btn-primary">
                            {this.state.sendButtonDisabled ? <FormattedMessage id="worldregion.form.savingChanges"/> : <FormattedMessage id="worldregion.form.saveChanges"/>}
                        </button>

                    </form>
                </div>
            </>
        );
    }
}

export default withRouter(injectIntl(WorldRegionForm));
